import styled from 'styled-components';

export const NavbarContainer = styled.nav`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  transition: ${({ theme }) => theme.transitions.default};
  background: ${({ scrolled, theme }) =>
    scrolled ? theme.colors.bg_navbar : 'transparent'};
  backdrop-filter: ${({ scrolled }) => (scrolled ? 'blur(20px)' : 'none')};
  border-bottom: ${({ scrolled, theme }) =>
    scrolled ? `1px solid ${theme.colors.border}` : '1px solid transparent'};
  box-shadow: ${({ scrolled, theme }) =>
    scrolled ? theme.shadows.navbar : 'none'};
`;

export const NavInner = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
`;

export const Logo = styled.a`
  font-size: 1.5rem;
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.heading};
  cursor: pointer;
  text-decoration: none;
  letter-spacing: -0.02em;

  span {
    background: ${({ theme }) => theme.colors.accent_gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;

export const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const NavLink = styled.a`
  color: ${({ active, theme }) =>
    active ? theme.colors.heading : theme.colors.para};
  font-size: 0.95rem;
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  cursor: pointer;
  text-decoration: none;
  position: relative;
  transition: ${({ theme }) => theme.transitions.default};
  padding: 0.25rem 0;

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: ${({ active }) => (active ? '100%' : '0')};
    height: 2px;
    background: ${({ theme }) => theme.colors.accent_gradient};
    border-radius: 1px;
    transition: ${({ theme }) => theme.transitions.default};
  }

  &:hover {
    color: ${({ theme }) => theme.colors.heading};

    &::after {
      width: 100%;
    }
  }
`;

export const NavCTA = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.5rem;
  font-size: 0.9rem;
  font-weight: ${({ theme }) => theme.fonts.weight.semibold};
  color: ${({ theme }) => theme.colors.white};
  background: ${({ theme }) => theme.colors.accent_gradient};
  border-radius: ${({ theme }) => theme.radius.full};
  cursor: pointer;
  text-decoration: none;
  transition: ${({ theme }) => theme.transitions.default};
  box-shadow: ${({ theme }) => theme.shadows.button};

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 25px rgba(59, 130, 246, 0.4);
  }
`;

export const ThemeToggle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid ${({ theme }) => theme.colors.glass_border};
  background: ${({ theme }) => theme.colors.bg_card};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  color: ${({ theme }) => theme.colors.heading};
  font-size: 1.15rem;
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.default};

  &:hover {
    border-color: ${({ theme }) => theme.colors.glass_border_hover};
    color: ${({ theme }) => theme.colors.accent};
    transform: rotate(15deg);
    box-shadow: 0 0 15px rgba(59, 130, 246, 0.15);
  }
`;

export const MobileActions = styled.div`
  display: none;
  align-items: center;
  gap: 0.75rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: flex;
  }
`;

export const MenuIcon = styled.button`
  display: none;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.heading};
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.25rem;
  transition: ${({ theme }) => theme.transitions.fast};

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: flex;
    align-items: center;
  }
`;

export const NavMenuContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background: ${({ theme }) => theme.colors.overlay};
  backdrop-filter: blur(20px);
  z-index: 200;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CloseIcon = styled.button`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.heading};
  font-size: 1.8rem;
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.fast};

  &:hover {
    color: ${({ theme }) => theme.colors.accent};
    transform: rotate(90deg);
  }
`;

export const MenuItem = styled.a`
  color: ${({ active, theme }) =>
    active ? theme.colors.accent : theme.colors.heading};
  font-size: 2rem;
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
  margin: 1rem 0;
  cursor: pointer;
  text-decoration: none;
  transition: ${({ theme }) => theme.transitions.default};
  position: relative;

  &:hover {
    color: ${({ theme }) => theme.colors.accent_light};
  }
`;
